import * as React from 'react';
import styled from 'styled-components';
import { Layout, Row } from 'antd';

export const RightAlignedRow = styled(Row)`
  text-align: right;
`;













